import "./MessageList.css";
import {
  FaArrowLeftLong,
  FaArrowRightLong,
  FaSortUp,
  FaSortDown,
} from "react-icons/fa6";
import React, { useState, useEffect } from "react";

const getDate = (isoTimestamp) =>
  new Date(isoTimestamp).toISOString().split("T")[0];
const getTime = (isoTimestamp) =>
  new Date(isoTimestamp).toISOString().split("T")[1].split(".")[0];

const MessageList = ({ messages }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrderDate, setSortOrderDate] = useState("asc"); 
  const [sortOrderMessage, setSortOrderMessage] = useState("asc"); 
  const [sortedMessages, setSortedMessages] = useState(messages); 

  const recordsPerPage = 25;
  const totalRecords = messages.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);

  const startIndex = (currentPage - 1) * recordsPerPage;
  const endIndex = startIndex + recordsPerPage;

  const sortByDate = (messages) => {
    return [...messages].sort((a, b) => {
      const dateA = new Date(a.dateReceived);
      const dateB = new Date(b.dateReceived);

      if (sortOrderDate === "asc") {
        return dateA - dateB; 
      } else {
        return dateB - dateA;
      }
    });
  };

  const sortByMessage = (messages) => {
    return [...messages].sort((a, b) => {
      if (sortOrderMessage === "asc") {
        return a.body.localeCompare(b.body); 
      } else {
        return b.body.localeCompare(a.body); 
      }
    });
  };

  const handleSortDate = () => {
    setSortOrderDate((prevOrder) => {
      const newOrder = prevOrder === "asc" ? "desc" : "asc";
      const sorted = sortByDate(messages);
      setSortedMessages(sorted);
      return newOrder;
    });
  };

  const handleSortMessage = () => {
    setSortOrderMessage((prevOrder) => {
      const newOrder = prevOrder === "asc" ? "desc" : "asc";
      const sorted = sortByMessage(messages);
      setSortedMessages(sorted);
      return newOrder;
    });
  };

  useEffect(() => {
    setSortedMessages(messages);
  }, [messages]);

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <>
      <div className="messageListBox">
        <div className="messageListHeader">
          <div className="messageListItem">
            <div className="phoneNumberBox">
              <p>Phone Number</p>
            </div>
            <div className="timeReceivedBox">
              <p>
                Time Received
                <span className="sortIcon" onClick={handleSortDate}>
                  {sortOrderDate === "asc" ? (
                    <FaSortUp size={20} />
                  ) : (
                    <FaSortDown size={20} />
                  )}
                </span>
              </p>
            </div>
            <div className="messageBox">
              <p>
                Message
                <span className="sortIcon" onClick={handleSortMessage}>
                  {sortOrderMessage === "asc" ? (
                    <FaSortUp size={20} />
                  ) : (
                    <FaSortDown size={20} />
                  )}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="messageListBody">
          {sortedMessages.slice(startIndex, endIndex).map((message, index) => (
            <div className="messageListItem" key={index}>
              <div className="phoneNumberBox">
                <p>{message.to}</p>
              </div>
              <div className="timeReceivedBox">
                <p>
                  {`${getDate(message.dateReceived)} ${getTime(
                    message.dateReceived
                  )}`}
                </p>
              </div>
              <div className="messageBox">
                <p>{message.body}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="paginationControls">
          <button
            type="button"
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
          >
            <FaArrowLeftLong size={24} />
          </button>
          <span className="pageIndicator">
            Page {currentPage} of {totalPages}
          </span>
          <button
            type="button"
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            <FaArrowRightLong size={24} />
          </button>
        </div>
      </div>
    </>
  );
};

export default MessageList;
